import TextSquare from '@/assets/icons/text-square.svg?react'
import Hash from '@/assets/icons/hash.svg?react'
import FileOutline from '@/assets/icons/file-outline.svg?react'
import { Calendar } from '@/assets/icons'
import { ColumnKind } from '../schemas'

export const columnIcons = {
  [ColumnKind.Text]: TextSquare,
  [ColumnKind.Number]: Hash,
  [ColumnKind.Date]: Calendar,
  file: FileOutline,
}
